import { render } from "./Titulo.vue?vue&type=template&id=7c6de027&scoped=true"
import script from "./Titulo.vue?vue&type=script&lang=js"
export * from "./Titulo.vue?vue&type=script&lang=js"

import "./Titulo.vue?vue&type=style&index=0&id=7c6de027&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6de027"]])

export default __exports__